<template>
  <SheetContainer
    title="连读"
    desc="长按最多选中10个字符，设置连读"
  >
    <ul class="sheet-list">
      <li
        v-for="(item, index) in options"
        :key="item.id"
        class="sheet-item"
        :class="{ checked: value === item.value }"
        @click="onSelect(index)"
      >
        <span>{{ item.name }}</span>
      </li>
      <li
        class="sheet-item remove"
        :class="{ removable }"
        @click="onRemoveClick"
      >
        <span>移除</span>
      </li>
    </ul>
  </SheetContainer>
</template>
<script>
import SheetContainer from "../sheet-container/sheet-container.vue";
import { customCollectEvent } from '@/utils/collect';
export default {
  props: {
    value: {
      // 选中值信息
      type: String,
      default: "",
    },
    selection: {
      // 选中信息
      type: Object,
      default: null,
    },
  },
  components: {
    SheetContainer,
  },
  data() {
    return {
      options: [
        { id: 1, name: "连读", checked: false, value: "1" }
      ], // 预置的重读选项
      selectedValue: "", //当前选中的值，未选中或者清除时值为""
    };
  },

  computed: {
    removable() {
      return this.value;
    },
  },
  watch: {
    value: {
      immediate: true,
      handler() {
        // debugger
        this.selectedValue = this.value;
      },
    },
  },
  methods: {
    // 校验选中是否合法

    isValid() {
     /*  if (this.selection.el) {
        if ($(this.selection.el).attr("data-type") !== "liandu") {
          toast("请选择需要设置的字符");
          return false;
        }
        return true;
      }
      if (!$(this.selection.el).attr("data-continuousid") &&!this.selection.rangeText || !this.selection.rangeText.trim()) {
        toast("请选择需要设置的字符");
        return false;
      }
      */
      return true;
    },
    //插入/修改重读
    onSelect(index) {
      if (!this.isValid()) return;
      const selected = this.options[index];
      this.updateValue(selected.value);
    },
    // 删除重读
    onRemoveClick() {
      if (!this.isValid()) return;
      this.updateValue("");
    },
    // 更新重读值
    updateValue(newValue) {
      // if (newValue !== this.selectedValue) {
        this.$emit("update:value", newValue);
        this.$emit("change", newValue);
        this.selectedValue = newValue;
        const option = this.options.find((option) => option.value === newValue);
        if (option) {
          customCollectEvent("editor_liandu", {
            type: option.name,
          });
        }
      
    },
  },
};
</script>
<style lang="less" scoped>
.sheet-list {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .sheet-item {
    width: 328px;
    height: 64px;

    &:first-child {
      margin-right: 0px;
    }

    &:last-child {
      margin-right: 0px;
    }
  }


}
</style>